/**
 * Converts Western digits in review widgets to Eastern Arabic numerals (٠-٩)
 * when the storefront language is Arabic.
 */
(() => {
  const lang = (document.documentElement.lang || '').toLowerCase();
  if (!lang.startsWith('ar')) return;

  const EASTERN = '٠١٢٣٤٥٦٧٨٩';
  const WESTERN_DIGIT = /[0-9]/;

  /**
   * @param {string | number} value
   * @returns {string}
   */
  const toEastern = (value) =>
    String(value).replace(/[0-9]/g, (digit) => EASTERN[Number(digit)]);

  window.ParajohnArabicNumerals = { toEastern, isArabic: true };

  const REVIEW_ROOT_SELECTOR = [
    '.jdgm-preview-badge',
    '.jdgm-prev-badge',
    '.jdgm-widget',
    '.jdgm-rev-widg',
    '.jdgm-review-widget',
    '#judgeme_product_reviews',
    '.judgeme-reviews',
    '[data-testimonials-rating]',
    '.testimonials__summary',
    '.rating-wrapper .rating-count',
    '.rsw-pdp-reviews',
  ].join(',');

  /**
   * @param {ParentNode} root
   */
  function convertTextNodes(root) {
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    /** @type {Text[]} */
    const nodes = [];
    while (walker.nextNode()) {
      nodes.push(/** @type {Text} */ (walker.currentNode));
    }

    for (const node of nodes) {
      const value = node.nodeValue;
      if (!value || !WESTERN_DIGIT.test(value)) continue;

      const parent = node.parentElement;
      if (!parent || parent.closest('script, style, noscript, textarea, input')) continue;

      node.nodeValue = toEastern(value);
    }
  }

  /**
   * @param {ParentNode} [scope]
   */
  function convertReviewNumbers(scope = document) {
    const roots =
      scope instanceof Element && scope.matches?.(REVIEW_ROOT_SELECTOR)
        ? [scope, ...scope.querySelectorAll(REVIEW_ROOT_SELECTOR)]
        : [...scope.querySelectorAll(REVIEW_ROOT_SELECTOR)];

    for (const root of roots) {
      convertTextNodes(root);
    }
  }

  const observer = new MutationObserver((mutations) => {
    let shouldRun = false;
    for (const mutation of mutations) {
      if (mutation.type === 'characterData') {
        const host = mutation.target.parentElement?.closest(REVIEW_ROOT_SELECTOR);
        if (host && WESTERN_DIGIT.test(mutation.target.nodeValue || '')) {
          convertTextNodes(host);
        }
        continue;
      }

      for (const node of mutation.addedNodes) {
        if (node.nodeType !== Node.ELEMENT_NODE) continue;
        const el = /** @type {Element} */ (node);
        if (el.matches?.(REVIEW_ROOT_SELECTOR) || el.querySelector?.(REVIEW_ROOT_SELECTOR)) {
          shouldRun = true;
          break;
        }
      }
      if (shouldRun) break;
    }

    if (shouldRun) convertReviewNumbers();
  });

  const start = () => {
    convertReviewNumbers();
    if (document.body) {
      observer.observe(document.body, {
        childList: true,
        subtree: true,
        characterData: true,
      });
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
